import React, { useEffect, useState } from 'react'
import react from "../assets/images/icons/react.png"
import typescript from "../assets/images/icons/typescript.png"
import angularjs from "../assets/images/icons/angular.png"
import nodejs from "../assets/images/icons/nodejs.png"
import mysql from "../assets/images/icons/mysql.png"
import bootstrap from "../assets/images/icons/bootstrap.png"
import native from "../assets/images/icons/nativee.png"
import aws from "../assets/images/icons/aws.png"
import gatsby from "../assets/images/icons/gatsby.png"
import mongodb from '../assets/images/icons/mongodb.png'
import tailwind from '../assets/images/icons/tailwind.png'
import python from "../assets/images/icons/icons-08.png"
import aos from 'aos'
import { Button } from 'react-bootstrap'


const Skills = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });


    }, [])
    const [show, setShow] = useState(0);
    return (
        <>
            {/* <!-- skill area Start --> */}
            <div id="skill" className="rn-skill-area rn-section-gap section-separator">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center" data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true">
                                <span className="subtitle">Visit my skill & Hire me</span>
                                <h2 className="title">My Skill</h2>
                            </div>
                            <div className="mt_md--40 mt_sm--40">
                                <ul className="skill-style-1">
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" title="Reactnative">
                                        <img src={native} alt="skill" />
                                    </li>
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" title="ReactJs">
                                        <img src={react} alt="skill" />
                                    </li>
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" title="Angular">
                                        <img src={angularjs} alt="skill" />
                                    </li>
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="200" data-aos-once="true" title="NodeJS">
                                        <img src={nodejs} alt="skill" />
                                    </li>

                                    
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="400" data-aos-once="true" title="Monogodb">
                                        <img src={mongodb} alt="skill" />
                                    </li>
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" title="Gatsby">
                                        <img src={gatsby} alt="skill" />
                                    </li>

                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" title="aws">
                                        <img src={aws} alt="skill" />
                                    </li>

                                   
                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" title="mysql">
                                        <img src={mysql} alt="skill" />
                                    </li>

                                    </ul>

                                    <ul style={{ display: `${show ? "" : "none"}` }} className="skill-style-1">
                                   

                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" title="tailwind">
                                        <img src={tailwind} alt="skill" />
                                    </li>


                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" title="typescript">
                                        <img src={typescript} alt="skill" />
                                    </li>


                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" title="bootstrap">
                                        <img src={bootstrap} alt="skill" />
                                    </li>

                                    <li data-aos="fade-up" data-aos-duration="500" data-aos-delay="200" data-aos-once="true" title="Python">
                                        <img src={python} alt="skill" />
                                    </li>


                                   


                                </ul>
                            </div>
                        </div>
                        <div
                            className="col-md-3 text-center morebutton"
                            onClick={() => {
                                setShow(!show);
                            }}
                        >


                            <a className="rn-btn mt-5"><span> {show ? "Show Less " : "Show More"}</span></a>

                            

                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- skill area End --> */}



        </>
    )
}

export default Skills